import React from "react";
import { InsWidget, InsWidgetTitle } from "components";
export const InsDefaultWidget = (props) => {
    const { sectionId, widgetId, groupId } = props;
    const dataMenu = [], title = React.createElement(InsWidgetTitle, { ...props });
    return React.createElement(InsWidget, { dataMenu: dataMenu, sectionId: sectionId, widgetId: widgetId, groupId: groupId, content: React.createElement("div", null, "In construction"), title: title });
};
